
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-blinkup.hbs';
import blinkupSDK from '@/lib/blinkup/blinkupsdk/blinkupSDK';

var BlinkupDialogView = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(template),
    ui: {
        header: 'modal-header',
        top_help_text: '.top-help-text',
        middle: '.middle',
        bottom_message: '.bottom-message',
        modal_footer: '.footer',
        pre_blinkup: '.pre-blinkup',
        countdown: '.countdown',
        during_blinkup: '.during-blinkup',
        polling: '.polling',
        success: '.blinkup-success',
        failure: '.failure',
        my_dev_btn: '.my-dev-btn',
        dev_details_btn: '.dev-details-btn',
        try_again: '.try-again',
        blinkup_title: '.modal-header',
        BU_canvas: '.BU-canvas',
        BU_progress: '.BU-progress',
        device_id: '.device-id',
        agent_url: '.agent-url',
    },
    events: {
        'click @ui.dev_details_btn': 'show_device_info',
        'click @ui.my_dev_btn': 'show_devices',
    },
    onDestroy: function(){
        blinkupSDK.stopFlash();
        blinkupSDK.stopPolling();
    },
    
    initialize: function (options) {
        this.destroyOnClose();
        this.focusFirstInput();
    },
    onRender: function() {
        this.start_countdown();
    },
    handle_submit: function(e) {
        e.preventDefault();
    },
    
    start_countdown: function() {
        var counter = 5;
        this.enable_countdown_state();
        var showCountdown = setInterval(function(){
            if (!this._isDestroyed) {
                counter--;
                this.ui.countdown.text(counter);
                if (counter === 0) {
                    clearInterval(showCountdown);
                    this.start_blinkup_flash();
                }
            } else {
                clearInterval(showCountdown);
            }
        }.bind(this), 1000);
    },
    start_blinkup_flash: function() {
        this.enable_blinkup_state();
        var self = this;
        blinkupSDK.startNetworkFlash(
            self.getOption('devConfigId'), 
            self.getOption('networkConfig'),
            self.start_polling.bind(self));
    },
    

    start_polling: function() {
        this.enable_polling_state();
        var self = this;
        blinkupSDK.pollForDevDeviceInfo(self.getOption('devConfigId'))
            .done(function(deviceInfo) {
                self.on_success.call(self, deviceInfo);
            })
            .fail(function(){
                self.on_error.apply(self, arguments);
            });
    },
    
    on_success: function (deviceInfo) {
        var apiCh = Radio.channel('api');
        var devices = apiCh.request('device');

        var device = devices.add({
            id: deviceInfo.deviceId,
        });
        device.fetch().done(function(){
            this.device = device;
            this.enable_blinkup_success_state(deviceInfo);
        }.bind(this))
        .fail(this.on_error);

        
    },
    on_error: function (error) {
        this.enable_blinkup_failure_state();
    },
    show_device_info: function(e){
        e.preventDefault();
        var self = this;

        var globalCh = Radio.channel('global');
        globalCh.request('show_device', self.device, 'device');
    },
    show_devices: function(e){
        e.preventDefault();
        var globalCh = Radio.channel('global');
        var primary_account = globalCh.request('primary_account');

        globalCh.request('show_my_development_devices', primary_account);
    },

    hide_all_ui: function() {
        this.ui.pre_blinkup.hide();
        this.ui.during_blinkup.hide();
        this.ui.polling.hide();
        this.ui.success.hide();
        this.ui.failure.hide();
        this.ui.header.hide();
        this.ui.top_help_text.hide();
        this.ui.middle.hide();
        this.ui.bottom_message.hide();
        this.ui.modal_footer.hide();
    },
    enable_countdown_state: function(){
        this.hide_all_ui();
        this.ui.header.show();
        this.ui.top_help_text.show();
        this.ui.middle.show();
        this.ui.bottom_message.show();
        this.ui.pre_blinkup.show();
    },
    enable_blinkup_state: function() {
        this.hide_all_ui();
        this.ui.middle.show();
        this.ui.during_blinkup.show();
    },
    enable_polling_state: function(){
        this.hide_all_ui();
        this.ui.header.show();
        this.ui.top_help_text.show();
        this.ui.middle.show();
        let animation = document.querySelector('.polling svg#imp-logo animate');
        animation.beginElement();
        this.ui.bottom_message.show();
        this.ui.modal_footer.show();
        this.ui.polling.show();
    },
    enable_blinkup_success_state: function(deviceInfo) {
        this.hide_all_ui();
        this.ui.header.show();
        this.ui.top_help_text.show();
        this.ui.middle.show();
        this.ui.bottom_message.show();
        this.ui.modal_footer.show();
        this.ui.success.show();

        this.ui.device_id.text(deviceInfo.deviceId);
        this.ui.agent_url.text(deviceInfo.agentURL);
    },

    enable_blinkup_failure_state: function() {
        this.hide_all_ui();
        this.ui.header.show();
        this.ui.top_help_text.show();
        this.ui.middle.show();
        this.ui.bottom_message.show();
        this.ui.modal_footer.show();
        this.ui.failure.show();
    },


});
export default BlinkupDialogView;

